(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freebie-unlock-button"] && !Shopify.designMode) return;
  try {
    // Check if user has already unlocked this product
  document.addEventListener('DOMContentLoaded', function() {
    const unlockBtn = document.querySelector('[data-freebie-unlock]');
    if (!unlockBtn) return;

    const productHandle = unlockBtn.dataset.productHandle;
    const unlockedProducts = JSON.parse(sessionStorage.getItem('unlockedFreebies') || '[]');

    if (unlockedProducts.includes(productHandle)) {
      // User has already unlocked - redirect to download page
      const downloadUrl = unlockBtn.dataset.downloadUrl || `/pages/download-${productHandle}`;
      unlockBtn.querySelector('.freebie-unlock-text__content').textContent = 'ACCESS YOUR DOWNLOAD';
      unlockBtn.classList.add('freebie-unlocked');

      unlockBtn.addEventListener('click', function() {
        window.location.href = downloadUrl;
      });
    } else {
      // Show modal to unlock
      unlockBtn.addEventListener('click', function() {
        const modal = document.querySelector('[data-freebie-modal]');
        if (modal) {
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';

          // Store product info for later use
          sessionStorage.setItem('currentFreebieHandle', productHandle);
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["freebie-unlock-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('[data-freebie-modal]');
    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-modal-close]');

    // Close modal handlers
    closeButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      });
    });

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    // Listen for Klaviyo form submission
    // Klaviyo triggers a custom event when form is submitted
    document.addEventListener('klaviyoForms', function(e) {
      if (e.detail.type === 'submit') {
        handleFormSubmission();
      }
    });

    // Alternative: Listen for form submission directly
    window.addEventListener('message', function(event) {
      // Klaviyo sends postMessage on form submission
      if (event.data && event.data.type === 'klaviyoFormSubmit') {
        handleFormSubmission();
      }
    });

    function handleFormSubmission() {
      const productHandle = sessionStorage.getItem('currentFreebieHandle');
      if (!productHandle) return;

      // Mark product as unlocked
      const unlockedProducts = JSON.parse(sessionStorage.getItem('unlockedFreebies') || '[]');
      if (!unlockedProducts.includes(productHandle)) {
        unlockedProducts.push(productHandle);
        sessionStorage.setItem('unlockedFreebies', JSON.stringify(unlockedProducts));
      }

      // Redirect to download page
      setTimeout(function() {
        window.location.href = `/pages/download-${productHandle}`;
      }, 500);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
